import { render, staticRenderFns } from "./PatientQuestionnaireRecommendations.vue?vue&type=template&id=1e502a79&scoped=true"
import script from "./PatientQuestionnaireRecommendations.vue?vue&type=script&lang=js"
export * from "./PatientQuestionnaireRecommendations.vue?vue&type=script&lang=js"
import style0 from "./PatientQuestionnaireRecommendations.vue?vue&type=style&index=0&id=1e502a79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e502a79",
  null
  
)

export default component.exports